module.exports = __webpack_public_path__ + "img/product-shot_01.ed7f5056.jpg";